import { Helmet } from 'react-helmet-async';
// @mui
import { styled } from '@mui/material/styles';
import { Link, Container, Typography, Divider, Stack, Button } from '@mui/material';
// hooks
import useResponsive from '../hooks/useResponsive';
// components
import Logo from '../components/logo';
import Iconify from '../components/iconify';
import cslogo from '../layouts/dashboard/nav/csalone.png';
// sections
import { LoginForm } from '../sections/auth/login';

// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const StyledSection = styled('div')(({ theme }) => ({
  width: '100%',
  maxWidth: 480,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  boxShadow: theme.customShadows.card,
  backgroundColor: theme.palette.background.default,
}));

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function LoginPage() {
  const mdUp = useResponsive('up', 'md');

  return (
    <>
      <Helmet>
        <title> Login | StrongMentorship </title>
      </Helmet>

      <StyledRoot>
        <Logo
          sx={{
            position: 'fixed',
            top: { xs: 16, sm: 24, md: 40 },
            left: { xs: 16, sm: 24, md: 40 },
          }}
        />

        {mdUp && (
          <StyledSection>
            <Typography variant="h3" sx={{ px: 5, mt: 10, mb: 5 }}>
              Hi, Welcome Back
            </Typography>
            {/* <img src="/assets/illustrations/illustration_login.png" alt="login" /> */}
          </StyledSection>
        )}

        <Container maxWidth="sm">
          <StyledContent>
            <Typography variant="h4" gutterBottom>
              Sign in to StrongMentorship
            </Typography>
            <br />
            <LoginForm />
          </StyledContent>
        </Container>

        <div style={{position:"absolute", bottom:"20px", left:"3%"}}>
          <div style={{textAlign:"center"}}>
            <div style={{display:"flex"}}>
              <img src={cslogo} alt="cslogo" style={{width:"60px", height:"52px", margin:"auto"}}/>
            </div>
                StrongMentorship
          </div>
          <hr />
          <div style={{fontSize:"12px", color:"grey", display:"flex"}}>© 2023 Software by&nbsp;
            <a href='https://strongs20.github.io/sam-portfolio' target="_blank" rel="noreferrer" className='MeLink' style={{color:"lightblue"}}>Samuel Strong</a>
          </div>
        </div>
      </StyledRoot>
    </>
  );
}
